import script from "./KeyboardShortcuts.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyboardShortcuts.vue?vue&type=script&setup=true&lang=js"

import "./KeyboardShortcuts.vue?vue&type=style&index=0&id=22285b90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22285b90"]])

export default __exports__